<ng-container *ngIf="!!get">
    <div class="col-xs-12 sp-0" style="display: flex; gap: 5px">
        <tt-card>
            <tt-input ttLabel="stat_cust_no" [(ttModel)]="get.stat_cust_no" ttReadonly></tt-input>
            <tt-textarea ttLabel="customer_name_and_address" [(ttModel)]="get.customer_name_and_address" ttReadonly></tt-textarea>
        </tt-card>
        <tt-card>
            <tt-input-number ttLabel="matcert_no" [(ttModel)]="get.matcert_no" ttTextAlign="right"></tt-input-number>
            <tt-input ttLabel="order_offer_no" [(ttModel)]="get.order_offer_no" ttReadonly></tt-input>
            <tt-input ttLabel="order_order_no" [(ttModel)]="get.order_order_no" ttReadonly></tt-input>
            <tt-date ttLabel="certificate_date" [(ttModel)]="get.certificate_date"></tt-date>
            <tt-input ttLabel="serialnos" [(ttModel)]="get.serialnos"></tt-input>
        </tt-card>
        <tt-card>
            <tt-textarea ttLabel="matcert_note1" [(ttModel)]="get.matcert_note1"></tt-textarea>
            <tt-textarea ttLabel="matcert_note2" [(ttModel)]="get.matcert_note2"></tt-textarea>
        </tt-card>
        <tt-card>
            <tt-input ttLabel="reg_by_portal_user_name" [ttModel]="get.reg_by_portal_user_name" ttReadonly></tt-input>
            <tt-datetime ttLabel="reg_datetime" [ttModel]="get.reg_datetime" ttReadonly></tt-datetime>
            <tt-input ttLabel="mod_by_portal_user_name" [ttModel]="get.mod_by_portal_user_name" ttReadonly></tt-input>
            <tt-datetime ttLabel="mod_datetime" [ttModel]="get.mod_datetime" ttReadonly></tt-datetime>
            <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
            <tt-button ttType="danger" ttText="delete" ttIcon="fad fa-trash" (ttClick)="deleteMatcert()" [ttLoading]="deleting"></tt-button>
            <!-- <tt-input ttLabel="order_internal_no" [(ttModel)]="get.order_internal_no" ttReadonly></tt-input> -->
        </tt-card>
    </div>
    <tt-tabs [(ttSelectedId)]="get.gb_matcert_main" (ttSelectedIdChange)="onTabChanged()">
        <tt-tab ttId="PRODUCTS" ttLabel="gb_matcert_main_products"></tt-tab>
        <tt-tab ttId="TESTS" ttLabel="gb_matcert_main_tests"></tt-tab>
    </tt-tabs>
    <tt-grid [hidden]="get.gb_matcert_main !== 'PRODUCTS'" *ngIf="!!grid" [(ttOptions)]="grid" class="flex-1"></tt-grid>
    <tt-grid [hidden]="get.gb_matcert_main !== 'TESTS'" *ngIf="!!testsGrid" [(ttOptions)]="testsGrid" class="flex-1"></tt-grid>
</ng-container>

<!-- {{ get | json }} -->
